import { Injectable } from '@angular/core';

import { AsyncJobType } from '@recruitee/account-data';
import { AsyncJobConfig } from '@recruitee/async-job';
import { NotificationStyle } from '@recruitee/user-interface';

@Injectable()
export class BulkCompaniesDeleteMembershipAsyncJob implements AsyncJobConfig {
  public readonly type = AsyncJobType.BulkCompaniesDeleteMembership;
  public readonly showDialog = false;
  public readonly showNotification = true;
  public readonly translations = {
    title: {
      success: 'app.async_jobs.bulk_companies_delete_membership.title.success',
      progress: 'app.async_jobs.bulk_companies_delete_membership.title.progress',
    },
  };

  public readonly skipNotificationMessages = true;
  public readonly skipProgressBar = true;
  public readonly workingNotificationStyle = NotificationStyle.InProgress;
}
